<template>
    <div>
		<Modal :open-state="show" @close="() => show = false" title="PIN код" dialog-class="modal-sm">
			<div class="PINTab">
				<input type="password" :value="pin" class="PINbox mb-3" disabled />
				<div class="text-center mb-1">
					<input type="button" class="PINbutton" value="1" @click="addNumberToPin('1')" />
					<input type="button" class="PINbutton" value="2" @click="addNumberToPin('2')" />
					<input type="button" class="PINbutton" value="3" @click="addNumberToPin('3')" />
				</div>

				<div class="text-center mb-1">
					<input type="button" class="PINbutton" value="4" @click="addNumberToPin('4')" />
					<input type="button" class="PINbutton" value="5" @click="addNumberToPin('5')" />
					<input type="button" class="PINbutton" value="6" @click="addNumberToPin('6')" />
				</div>
				<div class="text-center mb-1">
					<input type="button" class="PINbutton" value="7" @click="addNumberToPin('7')" />
					<input type="button" class="PINbutton" value="8" @click="addNumberToPin('8')" />
					<input type="button" class="PINbutton" value="9" @click="addNumberToPin('9')" />
				</div>

				<div class="text-center">
					<input type="button" class="PINbutton clear" value="clear" @click="pin = ''" />
					<input type="button" class="PINbutton" value="0" @click="addNumberToPin('0')" />
					<input type="button" class="PINbutton enter" value="enter" @click="checkPin()" />
				</div>
			</div>
		</Modal>
    </div>
</template>

<script>
    import Modal from "../blocks/Modal.vue";

	export default {
		components: {
			Modal
		},
        data() {
            return {
                pin: '',
				show: false
            }
        },
        mounted() {
            this.$root.emitter.on('showPin', () => {
                this.show = true;
            });
        },
        methods: {
            checkPin() {
                if (!this.pin) {
                    return this.$toast.error('Введите PIN код');
                }

                this.$root.axios.post('api/pin/auth', {
                    'pin': this.pin
                }).then((response) => {
                    if (response.data.success) {  
                        this.$root.getUser();  

                        this.$toast.success('Проверка пройдена');

						this.show = false;
                    }
                })
                .catch(error => {
                    this.pin = '';
                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            addNumberToPin(number) {
                this.pin = this.pin + number;
            }
        }
    }
</script>
<style scoped>
.PINTab input:focus,
.PINTab select:focus,
.PINTab textarea:focus,
.PINTab button:focus {
    outline: none;
}
.PINTab {
    text-align: center;
}
.PINbox {
    background: #ededed;
    width: 90%;
    font-size: 3em;
    text-align: center;
    border: 1px solid #d5d5d5;
}
.PINbutton {
    background: #ededed;
    color: #7e7e7e;
    border: none;
    background: linear-gradient(to bottom, #fafafa, #eaeaea);
    box-shadow: 0px 2px 2px -0px rgba(0,0,0,0.2);
    border-radius: 5px;
    font-size: 2em;
    text-align: center;
    width: 65px;
    height: 65px;
    margin: 5px 10px;
    padding: 0;
    cursor: pointer;
}
.clear, .enter {
    font-size: 1em;
    position: relative;
    top: -5px;
}
.PINbutton:hover {
    box-shadow: #005fee 0 0 1px 1px;
}
.PINbutton:active {
    background: #005fee;
    color: #fff;
}
.clear {
    box-shadow: #ff1c1c 0 0 1px 1px;
}
.clear:active {
    background: #ff1c1c;
    color: #fff;
}
.enter {
    box-shadow: #009f65 0 0 1px 1px;
}
.enter:active {
    background: #009f65;
    color: #fff;
}
.shadow {
    box-shadow: 0px 5px 5px -0px rgba(0,0,0,0.3);
}
</style>